/* eslint-disable no-unused-vars */
// LQC-2939 - template swaps from GET /Securities/swaps (dbo.Security, SWP + Benchmark).
// A template only pre-fills a ticket; nothing about it is sent. Most fields come back null
// (calendar, reference rate), so only what is present overrides the ticket's defaults.

export enum SwapSecurityField {
  securityName = "securityName",
}

export interface ISwapSecurity {
  [SwapSecurityField.securityName]: string; // "EUR IRS 5Y 6M", "EUR 12Y OIS", "GBP 14M UKRPI"
  startDate: string | null;
  maturityDate: string | null;
  cleared: boolean | null;
  interestType1: string | null;
  interestType2: string | null;
  couponFrequency1: string | null;
  couponFrequency2: string | null;
  resetFrequency1: string | null;
  resetFrequency2: string | null;
  currency1: string | null;
  currency2: string | null;
  dayCount1: string | null;
  dayCount2: string | null;
  businessDay1: string | null;
  businessDay2: string | null;
  calendar1: string | null;
  calendar2: string | null;
  referenceRate1: string | null;
  referenceRate2: string | null;
  settlementDays: number | null;
  yield: number | null;
  risk: number | null;
}

export interface ISwapSecuritiesResponse {
  swaps: ISwapSecurity[];
}
